export const backgroundNavy = '#07014a';